import React from 'react';
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardText,
  FormGroup,
  Label,
  Input,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Alert,
  UncontrolledTooltip
} from 'reactstrap';
import CadastroTopografiaModal from './modal/topografia.cadastro.component';
import CheckBox from '../../../../../../componentes/checkbox/checkbox.component';
import './receber.style.css';
import * as acessos from '../../../../../../acessos.const.util';
import SelectComponent from '@componentes/select/select.component';
import SelectCreatableComponent from '@componentes/select/select-creatable.component';
import IntlMessage from '../../../../../../helpers/intlMessage';
import { injectIntl } from 'react-intl';

const ReceberPage = (props) => {
  const {messages} = props.intl;
  return (
    <div className='receber-material-container'>
      <Modal
        centered
        isOpen={props.modalTopografia}
        toggle={() => props.toggleModalTopografia(undefined, undefined)}
      >
        <ModalHeader
          toggle={() => props.toggleModalTopografia(undefined, undefined)}
        >
          <IntlMessage id = "dashboards.examDetail.changeTopography"/>
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label><IntlMessage id = "dashboards.examDetail.topography"/></Label>
            <SelectComponent
              options={props.options}
              // placeholder={messages ['dashboards.examDetail.selectTopography']}
              onChange={e => {
                props.selecionarNovaTopografia(e.value, e.label);
              }}
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button
            color='secondary'
            onClick={() => props.toggleModalTopografia(undefined, undefined)}
          >
            <IntlMessage id = "dashboards.examDetails.cancel"/>
          </Button>
          <Button
            color='primary'
            onClick={() => {
              props.atualizarTopografia();
            }}
          >
            <IntlMessage id = "dashboards.examDetails.confirm"/>
          </Button>{' '}
        </ModalFooter>
      </Modal>
      <Modal
        centered
        isOpen={props.modalCancelFrasco}
        toggle={() => props.toggleModalCancelFrasco(undefined)}
      >
        <ModalHeader toggle={() => props.toggleModalCancelFrasco(undefined)}>
          <IntlMessage id = "dashboards.examDetail.bottleCancellation"/>
        </ModalHeader>
        <ModalBody>
          {props.isUltimoFrasco && (
            <FormGroup>
              <Alert color='danger'>
                <i className='fas fa-exclamation-circle'></i>
                {'  '}
                <IntlMessage id = "dashboards.examDetail.lastBottle"/>
              </Alert>
            </FormGroup>
          )}
          <FormGroup>
            <Label><IntlMessage id = "dashboards.examDetails.justification"/></Label>
            <Input
              type='textarea'
              value={props.justificativaCancelamentoFrasco}
              onChange={e =>
                props.onChangeJustificativaCancelamentoFrasco(
                  e.currentTarget.value
                )
              }
            />
          </FormGroup>
          {props.existeBlocoAndLamina && (
            <Row>
              <Col>
                <CheckBox
                  label={props.labelChekboxCancelarBlocoAndLaminas}
                  onChange={props.onChangeCheckboxCancelarBlocosAndLaminas}
                  checked={props.cancelarBlocoAndLaminas}
                ></CheckBox>
              </Col>
            </Row>
          )}
          <Row>
            {props.blocosExistentes.length > 0 && (
              <Col>
                <ul className='listagem-blocos-laminas-cancelamento'>
                  {props.blocosExistentes.map(el => (
                    <li>
                      <i className='fas fa-cubes'></i> {el}
                    </li>
                  ))}
                </ul>
              </Col>
            )}
            {props.laminasExistentes.length > 0 && (
              <Col>
                <ul className='listagem-blocos-laminas-cancelamento'>
                  {props.laminasExistentes.map(el => (
                    <li>
                      <i className='fas fa-square-full'></i> {el}
                    </li>
                  ))}
                </ul>
              </Col>
            )}
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            color='secondary'
            onClick={() => props.toggleModalCancelFrasco(undefined)}
          >
            <IntlMessage id = "dashboards.examDetails.cancel"/>
          </Button>
          <Button
            color='primary'
            disabled={
              !props.justificativaCancelamentoFrasco ||
              (props.existeBlocoAndLamina && !props.cancelarBlocoAndLaminas)
            }
            onClick={() => {
              props.cancelarFrasco();
            }}
          >
            <IntlMessage id = "dashboards.examDetails.confirm"/>
          </Button>{' '}
        </ModalFooter>
      </Modal>
      <CadastroTopografiaModal
        show={props.showModalCadastroTopografia}
        toggle={props.toggleModalCadastroTopografia}
        value={props.topografiaASerCadastrada}
        atualizarTopografia={props.atualizarTopografias}
        selecionarTopografiaRecemCadastrada={
          props.selecionarTopografiaRecemCadastrada
        }
      />
      {props.acessoPermitido(props.usuario, acessos.RastrearLaudo) &&
        props.acessoPermitido(props.usuario, acessos.RecebimentoMaterial) && (
          <div className='form-adicao-topografia'>
            <Row className='form-select-microscopista'>
              <Col className='label' xs='1'>
                <Label><IntlMessage id = "dashboards.examDetails.microscopist"/>:</Label>
              </Col>
              <Col>
                <SelectComponent
                  disabled={props.recebimentoFinalizado || props.exameFinalizado || !props.microAplicavel}
                  innerRef={props.medicoRef}
                  options={props.optionsMedicos}
                  value={props.medicoMicroscopistaSelecionado}
                  onChange={e => {props.onSelectMedicoMicroscopista(e)}}
                  isClearable={true}
                />
              </Col>
            </Row>
            <Row className='form-select-topografia'>
              <Col className='label' xs='1'>
                <Label><IntlMessage id = "dashboards.examDetail.topography"/></Label>
              </Col>
              <Col>
                <SelectCreatableComponent
                  disabled={props.recebimentoFinalizado || props.exameFinalizado}
                  innerRef={props.topografiaRef}
                  onChange={e=>props.onSelectTopografia(e)}
                  onCreateOption={props.handleCreateSelectCreatable}
                  options={props.options}
                  value={props.topografiaselecionada}
                />
              </Col>
              <Col className='label' xs='1'>
                <Label><IntlMessage id = "dashboards.examDetails.quantity"/></Label>
              </Col>
              <Col xs='1'>
                <Input
                  type='number'
                  min='1'
                  innerRef={props.quantidadeRef}
                  disabled={props.recebimentoFinalizado || props.exameFinalizado}
                  onChange={props.onChangeQuantidade}
                  value={props.quantidade}
                  onKeyPress={event => {
                    if (event.key === 'Enter') {
                      props.onSelectQuantidadeAdicionaFrasco(event);
                    }
                  }}
                ></Input>
              </Col>
              <Col sm='auto'>
                <Button
                  disabled={props.recebimentoFinalizado || props.exameFinalizado}
                  color='primary'
                  className='receber-page-adicionarfrasco'
                  onClick={props.onSelectQuantidadeAdicionaFrasco}
                >
                  <IntlMessage id = "dashboards.examDetail.adding"/>
                </Button>
              </Col>
            </Row>
          </div>
        )}
      <div className= 'item-topografia-card-container'>
        {props.frascosGravados.map(frasco => {
          let cancelado = frasco.status.toLowerCase() === 'cancelado';
          let tagFrasco = cancelado ? messages["dashboards.examDetails.tagCancelled"] : messages["dashboards.examDetails.tagSaved"];
          let isFrascoRecebimentoExterno =
            !cancelado &&
            !!props.frascoExterno &&
            props.frascoExterno === frasco.frascoId;
          const { exameFinalizado, recebimentoFinalizado } = props;
          return (
            <Row key={frasco.frascoId}>
              <Col>
                <Card>
                  <CardBody>
                    <CardTitle className='titulo-card'>
                      <div className='titulo-frasco'>
                        {`${frasco.topografia} ${tagFrasco}`}
                      </div>
                      {isFrascoRecebimentoExterno && (
                        <div className='icon-externo'>
                          <i
                            id={`icon-externo-` + frasco.frascoId}
                            className='fas fa-external-link-square-alt'
                          ></i>
                          <UncontrolledTooltip
                            placement='left'
                            target={`icon-externo-` + frasco.frascoId}
                          >
                            <IntlMessage id = "dashboards.examDetails.externalExamFlask"/> {`${props.nrExameExterno}`}
                          </UncontrolledTooltip>
                        </div>
                      )}
                    </CardTitle>
                    <CardText><IntlMessage id = "dashboards.examDetail.bottle"/> {`${frasco.dsFrasco}`}</CardText>
                    {!isFrascoRecebimentoExterno &&
                      (props.acessoPermitido(
                        props.usuario,
                        acessos.RastrearLaudo
                      ) ||
                        props.acessoPermitido(
                          props.usuario,
                          acessos.RecebimentoMaterial
                        )) &&
                      !cancelado &&
                      !exameFinalizado &&
                      !recebimentoFinalizado && (
                        <Button
                          className='mv-btn-icon'
                          style={{ marginRight: '38px' }}
                          onClick={() => {
                            props.toggleModalTopografia(
                              frasco.frascoId,
                              frasco.topografia
                            );
                          }}
                        >
                          <i className='fas fa-exchange-alt'></i>
                        </Button>
                      )}
                    {!isFrascoRecebimentoExterno &&
                      (props.acessoPermitido(
                        props.usuario,
                        acessos.RastrearLaudo
                      ) ||
                        props.acessoPermitido(
                          props.usuario,
                          acessos.RecebimentoMaterial
                        )) &&
                      !cancelado &&
                      !exameFinalizado &&
                      !recebimentoFinalizado && (
                        <Button
                          className='mv-btn-icon'
                          onClick={() => {
                            props.toggleModalCancelFrasco(frasco.frascoId);
                          }}
                        >
                          <i className='fas fa-trash'></i>
                        </Button>
                      )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          );
        })}
        {props.frascosNovos.map(frasco => {
          return (
            <Row key={`${frasco.dsFrasco}${frasco.nuOrdem}`}>
              <Col>
                <Card>
                  <CardBody>
                    <CardTitle>{`${frasco.dsTopografia}`} <IntlMessage id = "dashboards.examDetails.tagNew"/></CardTitle>
                    <CardText><IntlMessage id = "dashboards.examDetail.bottle"/> {`${frasco.dsFrasco}`}</CardText>
                    {props.acessoPermitido(
                      props.usuario,
                      acessos.RastrearLaudo
                    ) &&
                      props.acessoPermitido(
                        props.usuario,
                        acessos.RecebimentoMaterial
                      ) && (
                        <Button
                          className='mv-btn-icon'
                          onClick={() => {
                            props.onClickRemoveFrasco(frasco.dsFrasco);
                          }}
                        >
                          <i className='mv-basico-excluir'></i>
                        </Button>
                      )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          );
        })}
      </div>
    </div>
  );
};

export default injectIntl (ReceberPage);


// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/material/tabs/receber/receber.page.js